import { useMutation } from '@tanstack/react-query'
import { uploadDonationDepositReceipt } from '../utils/uploadDonationDepositReceipt'
import { useDonationsStore } from '../store/donationsStore'
import type { ApiError } from '@/types/api'
import { toast } from '@/integrations/toaster-provider'
import { notifyRequestError } from '@/utils/notifyRequestError'

export const useUploadDepositReceipt = () => {
  const update = useDonationsStore((s) => s.update)
  return useMutation({
    mutationFn: async ({
      donationId,
      depositDate,
      file,
      notes,
    }: {
      donationId: string
      depositDate: string
      file: File
      notes?: string
    }) => uploadDonationDepositReceipt(donationId, depositDate, file, notes),
    onSuccess: (data) => {
      update(data.donation)
      toast.success(data.message || 'Deposit receipt uploaded successfully')
    },
    onError: (error: ApiError) => {
      notifyRequestError(
        error,
        'An error occurred while uploading deposit receipt.',
      )
    },
  })
}
